import {TuiLanguage} from '@taiga-ui/i18n/interfaces';

import {TUI_DANISH_LANGUAGE_ADDON_COMMERCE} from './addon-commerce';
import {TUI_DANISH_LANGUAGE_ADDON_EDITOR} from './addon-editor';
import {TUI_DANISH_LANGUAGE_ADDON_PREVIEW} from './addon-preview';
import {TUI_DANISH_LANGUAGE_ADDON_TABLE} from './addon-table';
import {TUI_DANISH_LANGUAGE_CORE} from './core';
import {TUI_DANISH_LANGUAGE_KIT} from './kit';

export const TUI_DANISH_LANGUAGE: TuiLanguage = {
    name: `danish`,
    ...TUI_DANISH_LANGUAGE_CORE,
    ...TUI_DANISH_LANGUAGE_KIT,
    ...TUI_DANISH_LANGUAGE_ADDON_TABLE,
    ...TUI_DANISH_LANGUAGE_ADDON_COMMERCE,
    ...TUI_DANISH_LANGUAGE_ADDON_EDITOR,
    ...TUI_DANISH_LANGUAGE_ADDON_PREVIEW,
};
